import React, { type FunctionComponent } from 'react'
import { FormattedNumber } from 'react-intl'

interface Props {
  charge: number
}

export const OrdersListTableChargeCell: FunctionComponent<Props> = ({ charge }) => (
  <FormattedNumber
    value={charge}
    // eslint-disable-next-line
    style="currency"
    currency="USD"
  />
)
